import React from "react";

type ComponentProps = {};

const Page: React.FC<ComponentProps> = () => {
  return <>База знаний</>;
};

export default Page;
